<template>
  <v-card color="grey lighten-3">
    <v-toolbar dark :color="$store.state.global.pages.docket.color">
      <v-btn icon dark @click="close()">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Add Dockets</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <docket-control @addedDocket="$emit('addedDocket')" @addedAdjustment="addedAdjustment"></docket-control>
        </v-flex>

        <transition name="fade">
          <v-flex xs12>
            <trip-view></trip-view>
          </v-flex>
        </transition>
      </v-layout>
      <snack-bar ref="snackbar"></snack-bar>
    </v-container>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import DocketControl from "@/components/addDocket/docketControl";
import TripView from "@/components/addDocket/tripView";
export default {
  name: "DocketAdd",
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
    addedAdjustment(pdfDocket) {
      this.$emit("addedAdjustment", pdfDocket);
    }
  },
  components: {
    DocketControl,
    TripView
  },
  mounted() {}
};
</script>

<style scoped>
.rounded-card {
  border-radius: 6px;
  border-top-left-radius: 6px !important;
  border-top-right-radius: 6px !important;
}
</style>
